// Фронтовый поиск по строкам ABC-анализа: название блюда, его категории и коллекции.

function itemSearchText (item) {
  const menuItem = item.menuItem || {}
  const categories = menuItem.categories || []
  const collections = menuItem.collections || []

  return [
    menuItem.name,
    ...categories.map(category => category.name),
    ...collections.map(collection => collection.name),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
}

export function filterAbcItems (items, search) {
  const query = (search || '').trim().toLowerCase()

  if (!query) {
    return items
  }

  return items.filter(item => itemSearchText(item).includes(query))
}
